import { Component, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-note-expansion-panel[fieldName]',
  templateUrl: 'note-expansion-panel.component.html',
  styleUrls: ['./note-expansion-panel.component.scss'],
})
export class NoteExpansionPanel {
  @Input() fieldName: string;
  @Input() data: Record<string, any>;

  // hubspot data related.
  // @ts-ignore
  originalOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => 0;

  panelExpanded: boolean;
  constructor() {}
}
